var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", [
        _vm._v(
          _vm._s(_vm.$t("MAIN_CONTENT.thirdPartyAccess.manageThirdPartyAccess"))
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _c("p", [
          _vm._v(_vm._s(_vm.$t("MAIN_CONTENT.thirdPartyAccess.description")))
        ])
      ]),
      _vm._v(" "),
      _vm.clients.length === 0
        ? _c("div", { staticClass: "alert alert-info" }, [
            _c("p", [
              _vm._v(
                _vm._s(_vm.$t("MAIN_CONTENT.thirdPartyAccess.noClientsMessage"))
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.clients.length > 0
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-6 hidden-sm hidden-xs" }, [
              _c("h4", [
                _vm._v(_vm._s(_vm.$t("MAIN_CONTENT.thirdPartyAccess.client")))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-2 hidden-sm hidden-xs" }, [
              _c("h4", [
                _vm._v(
                  _vm._s(_vm.$t("MAIN_CONTENT.thirdPartyAccess.accessGranted"))
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-2 hidden-sm hidden-xs" }, [
              _c("h4", [
                _vm._v(_vm._s(_vm.$t("MAIN_CONTENT.thirdPartyAccess.lastUsed")))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-2 hidden-sm hidden-xs" }, [
              _vm._v("\n\t\t\t \n\t\t")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.clients, function(client) {
        return _c("div", { staticClass: "panel panel-default" }, [
          _c("div", { staticClass: "panel-body" }, [
            _c("div", { staticClass: "col-md-6" }, [
              _c("h5", [_vm._v(_vm._s(client.CLIENT_NAME))])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-2" }, [
              _c("h5", [
                _vm._v(_vm._s(_vm._f("datetime")(client.ACCESS_GRANTED_DATE)))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-2" }, [
              _c("h5", [
                _vm._v(_vm._s(_vm._f("datetime")(client.LAST_USED_DATE)))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-2 text-right" }, [
              _c(
                "a",
                {
                  staticClass: "btn btn-sm btn-danger",
                  attrs: { href: "javascript: void(0);" },
                  on: {
                    click: function($event) {
                      return _vm.revokeAccess(client.CLIENT_ID)
                    }
                  }
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("MAIN_CONTENT.thirdPartyAccess.revokeAccess"))
                  )
                ]
              )
            ])
          ])
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }